import { ChevronDown } from 'lucide-react'

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
  Label,
} from '@/components'
import type { Operator } from '@/stores'

interface ConditionSelectorProps {
  operatorOptions: Operator[]
  operator: string
  setOperator: (value: string) => void
}

export function ConditionSelector({
  operatorOptions,
  operator,
  setOperator,
}: ConditionSelectorProps) {
  const LabelComp = Label as any
  const MenuContent = DropdownMenuContent as any
  const RadioItem = DropdownMenuRadioItem as any

  return (
    <div className="grid gap-2">
      <LabelComp>Condition</LabelComp>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            theme="outline"
            className="w-full justify-between font-normal"
          >
            {operatorOptions.find((op) => op.value === operator)?.label ||
              'Select condition'}
            <ChevronDown className="h-4 w-4 opacity-50" />
          </Button>
        </DropdownMenuTrigger>
        <MenuContent className="w-(--radix-dropdown-menu-trigger-width)">
          <DropdownMenuRadioGroup value={operator} onValueChange={setOperator}>
            {operatorOptions.map((op) => (
              <RadioItem key={op.value} value={op.value}>
                {op.label}
              </RadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </MenuContent>
      </DropdownMenu>
    </div>
  )
}
